export const Donations = [500, 1000, 2000, 3000, 4000];

export const Tax = 0.1;

export const SUBSCRIPTION_WINDOWS = {
  CANCELLATION_DAYS: 7,
  RENEWAL_DAYS: 15, //ajustado para atender regra do email que é enviado para renovação com 15d de antecedência.
} as const;

export const ErrorCodes = {
  VALIDATION_ERROR_CODE: 282828,
  UNKNOWN_DATABASE_ERROR: 303030,
  TICKETS_NOT_AVAILABLE: 101010,
  INVALID_SESSION_TIME_RANGE: 232323,
  EXPERIENCE_ID_DOES_NOT_EXISTS: 404040,
  UNAVAILABLE_DAY_SALES_SCRIPT: 323232,
  CONFIGURATION_ID_DOES_NOT_EXISTS: 414141,
  CONFIGURATION_DOES_NOT_EXISTS: 424242,
  INVALID_CONFIUGRATION_TICKET_TYPES: 121212,
  TICKETS_ARE_UNAVAILABLE: 212121,
  CONFIGURATION_TIME_CONFLICT: 3232322,
  UNKNOWN_ERROR: 202122,
  USER_PHONE_ALREADY_EXISTS: 242424,
  AUTH_ERROR: 656565,
  USER_DOES_NOT_EXISTS: 303020,
  ERROR_RESERVATION_SEATS: 400647,
  SUBSCRIPTION_ALREADY_ACTIVE: 400725,
  TITULAR_SUBSCRIPTION_NOT_ACTIVE: 400726,
  CONFIRM_CODE_RATE_LIMITED: 400809,
};

export const BrazilTimeZone = 'America/Sao_Paulo';

export const BrazilTimeZoneOffset = 3;

export const COUNTRIES = [
  {
    name: {
      'pt-BR': 'Afeganistão',
      es: 'Afganistán',
      en: 'Afghanistan',
    },
    code: 'AF',
    timezone: 'Afghanistan Standard Time',
    utc: 'UTC+04:30',
    mobileCode: '+93',
  },
  {
    name: {
      'pt-BR': 'Ilhas Aland',
      es: 'Islas Åland',
      en: 'Åland Islands',
    },
    code: 'AX',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+358-18',
  },
  {
    name: {
      'pt-BR': 'Albânia',
      es: 'Albania',
      en: 'Albania',
    },
    code: 'AL',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+355',
  },
  {
    name: {
      'pt-BR': 'Argélia',
      es: 'Argelia',
      en: 'Algeria',
    },
    code: 'DZ',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+213',
  },
  {
    name: {
      'pt-BR': 'Samoa Americana',
      es: 'Samoa Americana',
      en: 'American Samoa',
    },
    code: 'AS',
    timezone: 'UTC-11',
    utc: 'UTC-11:00',
    mobileCode: '+1-684',
  },
  {
    name: {
      'pt-BR': 'Andorra',
      es: 'Andorra',
      en: 'Andorra',
    },
    code: 'AD',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+376',
  },
  {
    name: {
      'pt-BR': 'Angola',
      es: 'Angola',
      en: 'Angola',
    },
    code: 'AO',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+244',
  },
  {
    name: {
      'pt-BR': 'Anguilla',
      es: 'Anguila',
      en: 'Anguilla',
    },
    code: 'AI',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-264',
  },
  {
    name: {
      'pt-BR': 'Antártida',
      es: 'Antártida',
      en: 'Antarctica',
    },
    code: 'AQ',
    timezone: 'Pacific SA Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+',
  },
  {
    name: {
      'pt-BR': 'Antígua e Barbuda',
      es: 'Antigua y Barbuda',
      en: 'Antigua and Barbuda',
    },
    code: 'AG',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-268',
  },
  {
    name: {
      'pt-BR': 'Argentina',
      es: 'Argentina',
      en: 'Argentina',
    },
    code: 'AR',
    timezone: 'Argentina Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+54',
  },
  {
    name: {
      'pt-BR': 'Armênia',
      es: 'Armenia',
      en: 'Armenia',
    },
    code: 'AM',
    timezone: 'Caucasus Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+374',
  },
  {
    name: {
      'pt-BR': 'Aruba',
      es: 'Aruba',
      en: 'Aruba',
    },
    code: 'AW',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+297',
  },
  {
    name: {
      'pt-BR': 'Austrália',
      es: 'Australia',
      en: 'Australia',
    },
    code: 'AU',
    timezone: 'AUS Eastern Standard Time',
    utc: 'UTC+10:00',
    mobileCode: '+61',
  },
  {
    name: {
      'pt-BR': 'Áustria',
      es: 'Austria',
      en: 'Austria',
    },
    code: 'AT',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+43',
  },
  {
    name: {
      'pt-BR': 'Azerbeijão',
      es: 'Azerbaijan',
      en: 'Azerbaijan',
    },
    code: 'AZ',
    timezone: 'Azerbaijan Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+994',
  },
  {
    name: {
      'pt-BR': 'Bahamas',
      es: 'Las Bahamas',
      en: 'The Bahamas',
    },
    code: 'BS',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+1-242',
  },
  {
    name: {
      'pt-BR': 'Barém',
      es: 'Baréin',
      en: 'Bahrain',
    },
    code: 'BH',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+973',
  },
  {
    name: {
      'pt-BR': 'Bangladexe',
      es: 'Bangladesh',
      en: 'Bangladesh',
    },
    code: 'BD',
    timezone: 'Bangladesh Standard Time',
    utc: 'UTC+06:00',
    mobileCode: '+880',
  },
  {
    name: {
      'pt-BR': 'Barbados',
      es: 'Barbados',
      en: 'Barbados',
    },
    code: 'BB',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-246',
  },
  {
    name: {
      'pt-BR': 'Bielorrússia',
      es: 'Bielorrusia',
      en: 'Belarus',
    },
    code: 'BY',
    timezone: 'Belarus Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+375',
  },
  {
    name: {
      'pt-BR': 'Bélgica',
      es: 'Bélgica',
      en: 'Belgium',
    },
    code: 'BE',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+32',
  },
  {
    name: {
      'pt-BR': 'Belize',
      es: 'Belize',
      en: 'Belize',
    },
    code: 'BZ',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    mobileCode: '+501',
  },
  {
    name: {
      'pt-BR': 'Benim',
      es: 'Benín',
      en: 'Benin',
    },
    code: 'BJ',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+229',
  },
  {
    name: {
      'pt-BR': 'Bermudas',
      es: 'Bermudas',
      en: 'Bermuda',
    },
    code: 'BM',
    timezone: 'Atlantic Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-441',
  },
  {
    name: {
      'pt-BR': 'Butão',
      es: 'Bután',
      en: 'Bhutan',
    },
    code: 'BT',
    timezone: 'Bangladesh Standard Time',
    utc: 'UTC+06:00',
    mobileCode: '+975',
  },
  {
    name: {
      'pt-BR': 'República Bolivariana da Venezuela',
      es: 'República Bolivariana de Venezuela',
      en: 'Bolivarian Republic of Venezuela',
    },
    code: 'VE',
    timezone: 'Venezuela Standard Time',
    utc: 'UTC-04:30',
    mobileCode: '+58',
  },
  {
    name: {
      'pt-BR': 'Bolívia',
      es: 'Bolivia',
      en: 'Bolivia',
    },
    code: 'BO',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+591',
  },
  {
    name: {
      'pt-BR': 'Bonaire, Sint Eustatius e Saba',
      es: 'Bonaire, Sint Eustatius y Saba',
      en: 'Bonaire, Sint Eustatius and Saba',
    },
    code: 'BQ',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+599',
  },
  {
    name: {
      'pt-BR': 'Bósnia e Herzegovina',
      es: 'Bosnia y Herzegovina',
      en: 'Bosnia and Herzegovina',
    },
    code: 'BA',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+387',
  },
  {
    name: {
      'pt-BR': 'Botswana',
      es: 'Botsuana',
      en: 'Botswana',
    },
    code: 'BW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+267',
  },
  {
    name: {
      'pt-BR': 'Ilha Bouvet',
      es: 'Isla Bouvet',
      en: 'Bouvet Island',
    },
    code: 'BV',
    timezone: 'UTC',
    utc: 'UTC',
    mobileCode: '+100',
  },
  {
    name: {
      'pt-BR': 'Brasil',
      es: 'Brasil',
      en: 'Brazil',
    },
    code: 'BR',
    timezone: 'E. South America Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+55',
  },
  {
    name: {
      'pt-BR': 'Território Britânico do Oceano Índico',
      es: 'Territorio Británico del Océano Índico',
      en: 'British Indian Ocean Territory',
    },
    code: 'IO',
    timezone: 'Central Asia Standard Time',
    utc: 'UTC+06:00',
    mobileCode: '+246',
  },
  {
    name: {
      'pt-BR': 'Bulgária',
      es: 'Bulgaria',
      en: 'Bulgaria',
    },
    code: 'BG',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+359',
  },
  {
    name: {
      'pt-BR': 'Burquina Fasso',
      es: 'Burkina Faso',
      en: 'Burkina Faso',
    },
    code: 'BF',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+226',
  },
  {
    name: {
      'pt-BR': 'Burundi',
      es: 'Burundi',
      en: 'Burundi',
    },
    code: 'BI',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+257',
  },
  {
    name: {
      'pt-BR': 'Cabo Verde',
      es: 'Cabo Verde',
      en: 'Cape Verde',
    },
    code: 'CV',
    timezone: 'Cape Verde Standard Time',
    utc: 'UTC-01:00',
    mobileCode: '+238',
  },
  {
    name: {
      'pt-BR': 'Camarões',
      es: 'Camerún',
      en: 'Cameroon',
    },
    code: 'CM',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+237',
  },
  {
    name: {
      'pt-BR': 'Canadá',
      es: 'Canadá',
      en: 'Canada',
    },
    code: 'CA',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+1',
  },
  {
    name: {
      'pt-BR': 'Ilhas Cayman',
      es: 'Islas Cayman',
      en: 'Cayman Islands',
    },
    code: 'KY',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+1-345',
  },
  {
    name: {
      'pt-BR': 'República Centro-Africana',
      es: 'República Centroafricana',
      en: 'Central African Republic',
    },
    code: 'CF',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+236',
  },
  {
    name: {
      'pt-BR': 'Chade',
      es: 'Chad',
      en: 'Chad',
    },
    code: 'TD',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+235',
  },
  {
    name: {
      'pt-BR': 'Chile',
      es: 'Chile',
      en: 'Chile',
    },
    code: 'CL',
    timezone: 'Pacific SA Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+56',
  },
  {
    name: {
      'pt-BR': 'China',
      es: 'China',
      en: 'China',
    },
    code: 'CN',
    timezone: 'China Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+86',
  },
  {
    name: {
      'pt-BR': 'Ilha Christmas',
      es: 'Isla Christmas',
      en: 'Christmas Island',
    },
    code: 'CX',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    mobileCode: '+61',
  },
  {
    name: {
      'pt-BR': 'Ilhas Cocos (Keeling)',
      es: 'Islas Cocos (Keeling)',
      en: 'Cocos (Keeling) Islands',
    },
    code: 'CC',
    timezone: 'Myanmar Standard Time',
    utc: 'UTC+06:30',
    mobileCode: '+61',
  },
  {
    name: {
      'pt-BR': 'Colômbia',
      es: 'Colombia',
      en: 'Colombia',
    },
    code: 'CO',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+57',
  },
  {
    name: {
      'pt-BR': 'Comores',
      es: 'Comoras',
      en: 'Comoros',
    },
    code: 'KM',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+269',
  },
  {
    name: {
      'pt-BR': 'Congo',
      es: 'Congo',
      en: 'Congo',
    },
    code: 'CG',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+242',
  },
  {
    name: {
      'pt-BR': 'Congo (República Democrática do Congo)',
      es: 'Congo (República Democrática del Congo)',
      en: 'Congo (DRC)',
    },
    code: 'CD',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+243',
  },
  {
    name: {
      'pt-BR': 'Ilhas Cook',
      es: 'Islas Cook',
      en: 'Cook Islands',
    },
    code: 'CK',
    timezone: 'Hawaiian Standard Time',
    utc: 'UTC-10:00',
    mobileCode: '+682',
  },
  {
    name: {
      'pt-BR': 'Costa Rica',
      es: 'Costa Rica',
      en: 'Costa Rica',
    },
    code: 'CR',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    mobileCode: '+506',
  },
  {
    name: {
      'pt-BR': 'Costa do Marfim',
      es: "Côte d'Ivoire",
      en: "Côte d'Ivoire",
    },
    code: 'CI',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+225',
  },
  {
    name: {
      'pt-BR': 'Croácia',
      es: 'Croacia',
      en: 'Croatia',
    },
    code: 'HR',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+385',
  },
  {
    name: {
      'pt-BR': 'Cuba',
      es: 'Cuba',
      en: 'Cuba',
    },
    code: 'CU',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+53',
  },
  {
    name: {
      'pt-BR': 'Curaçao',
      es: 'Curazao',
      en: 'Curaçao',
    },
    code: 'CW',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+599',
  },
  {
    name: {
      'pt-BR': 'Chipre',
      es: 'Chipre',
      en: 'Cyprus',
    },
    code: 'CY',
    timezone: 'E. Europe Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+357',
  },
  {
    name: {
      'pt-BR': 'República Tcheca',
      es: 'República Checa',
      en: 'Czech Republic',
    },
    code: 'CZ',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+420',
  },
  {
    name: {
      'pt-BR': 'Timor-Leste',
      es: 'Timor Oriental',
      en: 'Democratic Republic of Timor-Leste',
    },
    code: 'TL',
    timezone: 'Tokyo Standard Time',
    utc: 'UTC+09:00',
    mobileCode: '+670',
  },
  {
    name: {
      'pt-BR': 'Dinamarca',
      es: 'Dinamarca',
      en: 'Denmark',
    },
    code: 'DK',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+45',
  },
  {
    name: {
      'pt-BR': 'Djibuti',
      es: 'Djibuti',
      en: 'Djibouti',
    },
    code: 'DJ',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+253',
  },
  {
    name: {
      'pt-BR': 'Domínica',
      es: 'Dominica',
      en: 'Dominica',
    },
    code: 'DM',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-767',
  },
  {
    name: {
      'pt-BR': 'República Dominicana',
      es: 'República Dominicana',
      en: 'Dominican Republic',
    },
    code: 'DO',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-809 and 1-829',
  },
  {
    name: {
      'pt-BR': 'Equador',
      es: 'Ecuador',
      en: 'Ecuador',
    },
    code: 'EC',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+593',
  },
  {
    name: {
      'pt-BR': 'Egito',
      es: 'Egipto',
      en: 'Egypt',
    },
    code: 'EG',
    timezone: 'Egypt Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+20',
  },
  {
    name: {
      'pt-BR': 'El Salvador',
      es: 'El Salvador',
      en: 'El Salvador',
    },
    code: 'SV',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    mobileCode: '+503',
  },
  {
    name: {
      'pt-BR': 'Guiné Equatorial',
      es: 'Guinea Ecuatorial',
      en: 'Equatorial Guinea',
    },
    code: 'GQ',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+240',
  },
  {
    name: {
      'pt-BR': 'Eritreia',
      es: 'Eritrea',
      en: 'Eritrea',
    },
    code: 'ER',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+291',
  },
  {
    name: {
      'pt-BR': 'Estónia',
      es: 'Estonia',
      en: 'Estonia',
    },
    code: 'EE',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+372',
  },
  {
    name: {
      'pt-BR': 'Etiópia',
      es: 'Etiopía',
      en: 'Ethiopia',
    },
    code: 'ET',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+251',
  },
  {
    name: {
      'pt-BR': 'Ilhas Falkland (Malvinas)',
      es: 'Islas Falkland (Malvinas)',
      en: 'Falkland',
    },
    code: 'FK',
    timezone: 'SA Eastern Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+500',
  },
  {
    name: {
      'pt-BR': 'Ilhas Faroés',
      es: 'Islas Faroe',
      en: 'Faroe Islands',
    },
    code: 'FO',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+298',
  },
  {
    name: {
      'pt-BR': 'Ilhas Fiji',
      es: 'Islas Fiji',
      en: 'Fiji Islands',
    },
    code: 'FJ',
    timezone: 'Fiji Standard Time',
    utc: 'UTC+12:00',
    mobileCode: '+679',
  },
  {
    name: {
      'pt-BR': 'Finlândia',
      es: 'Finlandia',
      en: 'Finland',
    },
    code: 'FI',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+358',
  },
  {
    name: {
      'pt-BR': 'França',
      es: 'Francia',
      en: 'France',
    },
    code: 'FR',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+33',
  },
  {
    name: {
      'pt-BR': 'Guiana Francesa',
      es: 'Guayana Francesa',
      en: 'French Guiana',
    },
    code: 'GF',
    timezone: 'SA Eastern Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+594',
  },
  {
    name: {
      'pt-BR': 'Polinésia Francesa',
      es: 'Polinesia Francesa',
      en: 'French Polynesia',
    },
    code: 'PF',
    timezone: 'Hawaiian Standard Time',
    utc: 'UTC-10:00',
    mobileCode: '+689',
  },
  {
    name: {
      'pt-BR': 'Gabão',
      es: 'Gabón',
      en: 'Gabon',
    },
    code: 'GA',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+241',
  },
  {
    name: {
      'pt-BR': 'Gâmbia',
      es: 'Gambia',
      en: 'The Gambia',
    },
    code: 'GM',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+220',
  },
  {
    name: {
      'pt-BR': 'Geórgia',
      es: 'Georgia',
      en: 'Georgia',
    },
    code: 'GE',
    timezone: 'Georgian Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+995',
  },
  {
    name: {
      'pt-BR': 'Alemanha',
      es: 'Alemania',
      en: 'Germany',
    },
    code: 'DE',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+49',
  },
  {
    name: {
      'pt-BR': 'Gana',
      es: 'Ghana',
      en: 'Ghana',
    },
    code: 'GH',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+233',
  },
  {
    name: {
      'pt-BR': 'Gibraltar',
      es: 'Gibraltar',
      en: 'Gibraltar',
    },
    code: 'GI',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+350',
  },
  {
    name: {
      'pt-BR': 'Grécia',
      es: 'Grecia',
      en: 'Greece',
    },
    code: 'GR',
    timezone: 'GTB Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+30',
  },
  {
    name: {
      'pt-BR': 'Groelândia',
      es: 'Groenlandia',
      en: 'Greenland',
    },
    code: 'GL',
    timezone: 'Greenland Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+299',
  },
  {
    name: {
      'pt-BR': 'Granada',
      es: 'Granada',
      en: 'Grenada',
    },
    code: 'GD',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-473',
  },
  {
    name: {
      'pt-BR': 'Guadalupe',
      es: 'Guadalupe',
      en: 'Guadeloupe',
    },
    code: 'GP',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+590',
  },
  {
    name: {
      'pt-BR': 'Guam',
      es: 'Guam',
      en: 'Guam',
    },
    code: 'GU',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    mobileCode: '+1-671',
  },
  {
    name: {
      'pt-BR': 'Guatemala',
      es: 'Guatemala',
      en: 'Guatemala',
    },
    code: 'GT',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    mobileCode: '+502',
  },
  {
    name: {
      'pt-BR': 'Guernsey',
      es: 'Guernesey',
      en: 'Guernsey',
    },
    code: 'GG',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+44-1481',
  },
  {
    name: {
      'pt-BR': 'Guiné',
      es: 'Guinea',
      en: 'Guinea',
    },
    code: 'GN',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+224',
  },
  {
    name: {
      'pt-BR': 'Guiné-Bissau',
      es: 'Guinea-Bisáu',
      en: 'Guinea-Bissau',
    },
    code: 'GW',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+245',
  },
  {
    name: {
      'pt-BR': 'Guiana',
      es: 'Guyana',
      en: 'Guyana',
    },
    code: 'GY',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+592',
  },
  // {
  //   name: {
  //     'pt-BR': 'Haiti',
  //     es: 'Haití',
  //     en: 'Haiti',
  //   },
  //   code: 'HT',
  //   timezone: 'Eastern Standard Time',
  //   utc: 'UTC-05:00',
  //   mobileCode: '+509',
  // },
  {
    name: {
      'pt-BR': 'Ilha Heard e Ilhas McDonald',
      es: 'Isla Heard y las Islas McDonald',
      en: 'Heard Island and McDonald Islands',
    },
    code: 'HM',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+672',
  },
  {
    name: {
      'pt-BR': 'Honduras',
      es: 'Honduras',
      en: 'Honduras',
    },
    code: 'HN',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    mobileCode: '+504',
  },
  {
    name: {
      'pt-BR': 'Hong Kong SAR',
      es: 'Hong Kong SAR',
      en: 'Hong Kong SAR',
    },
    code: 'HK',
    timezone: 'China Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+852',
  },
  {
    name: {
      'pt-BR': 'Hungria',
      es: 'Hungría',
      en: 'Hungary',
    },
    code: 'HU',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+36',
  },
  {
    name: {
      'pt-BR': 'Islândia',
      es: 'Islandia',
      en: 'Iceland',
    },
    code: 'IS',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+354',
  },
  {
    name: {
      'pt-BR': 'Índia',
      es: 'India',
      en: 'India',
    },
    code: 'IN',
    timezone: 'India Standard Time',
    utc: 'UTC+05:30',
    mobileCode: '+91',
  },
  {
    name: {
      'pt-BR': 'Indonésia',
      es: 'Indonesia',
      en: 'Indonesia',
    },
    code: 'ID',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    mobileCode: '+62',
  },
  {
    name: {
      'pt-BR': 'Irã',
      es: 'Irán',
      en: 'Iran',
    },
    code: 'IR',
    timezone: 'Iran Standard Time',
    utc: 'UTC+03:30',
    mobileCode: '+98',
  },
  {
    name: {
      'pt-BR': 'Iraque',
      es: 'Irak',
      en: 'Iraq',
    },
    code: 'IQ',
    timezone: 'Arabic Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+964',
  },
  {
    name: {
      'pt-BR': 'Irlanda',
      es: 'Irlanda',
      en: 'Ireland',
    },
    code: 'IE',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+353',
  },
  {
    name: {
      'pt-BR': 'Israel',
      es: 'Israel',
      en: 'Israel',
    },
    code: 'IL',
    timezone: 'Israel Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+972',
  },
  {
    name: {
      'pt-BR': 'Itália',
      es: 'Italia',
      en: 'Italy',
    },
    code: 'IT',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+39',
  },
  {
    name: {
      'pt-BR': 'Jamaica',
      es: 'Jamaica',
      en: 'Jamaica',
    },
    code: 'JM',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+1-876',
  },
  {
    name: {
      'pt-BR': 'Jan Mayen',
      es: 'Jan Mayen',
      en: 'Jan Mayen',
    },
    code: 'SJ',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+47',
  },
  {
    name: {
      'pt-BR': 'Japão',
      es: 'Japón',
      en: 'Japan',
    },
    code: 'JP',
    timezone: 'Tokyo Standard Time',
    utc: 'UTC+09:00',
    mobileCode: '+81',
  },
  {
    name: {
      'pt-BR': 'Jersey',
      es: 'Jersey',
      en: 'Jersey',
    },
    code: 'JE',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+44-1534',
  },
  {
    name: {
      'pt-BR': ' Jordânia',
      es: 'Jordania',
      en: 'Jordan',
    },
    code: 'JO',
    timezone: 'Jordan Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+962',
  },
  {
    name: {
      'pt-BR': 'Cazaquistão',
      es: 'Kazajistán',
      en: 'Kazakhstan',
    },
    code: 'KZ',
    timezone: 'Central Asia Standard Time',
    utc: 'UTC+06:00',
    mobileCode: '+7',
  },
  {
    name: {
      'pt-BR': 'Quênia',
      es: 'Kenia',
      en: 'Kenya',
    },
    code: 'KE',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+254',
  },
  {
    name: {
      'pt-BR': 'Kiribati',
      es: 'Kiribati',
      en: 'Kiribati',
    },
    code: 'KI',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    mobileCode: '+686',
  },
  {
    name: {
      'pt-BR': 'Coreia',
      es: 'Corea del Sur',
      en: 'Korea',
    },
    code: 'KR',
    timezone: 'Korea Standard Time',
    utc: 'UTC+09:00',
    mobileCode: '+82',
  },
  {
    name: {
      'pt-BR': 'Kosovo',
      es: 'Kosovo',
      en: 'Kosovo',
    },
    code: 'XK',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+383',
  },
  {
    name: {
      'pt-BR': 'Kuwait',
      es: 'Kuwait',
      en: 'Kuwait',
    },
    code: 'KW',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+965',
  },
  {
    name: {
      'pt-BR': 'Quirguistão',
      es: 'Kirguistán',
      en: 'Kyrgyzstan',
    },
    code: 'KG',
    timezone: 'Central Asia Standard Time',
    utc: 'UTC+06:00',
    mobileCode: '+996',
  },
  {
    name: {
      'pt-BR': 'Laos',
      es: 'Laos',
      en: 'Laos',
    },
    code: 'LA',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    mobileCode: '+856',
  },
  {
    name: {
      'pt-BR': 'Letônia',
      es: 'Letonia',
      en: 'Latvia',
    },
    code: 'LV',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+371',
  },
  {
    name: {
      'pt-BR': 'Líbano',
      es: 'Líbano',
      en: 'Lebanon',
    },
    code: 'LB',
    timezone: 'Middle East Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+961',
  },
  {
    name: {
      'pt-BR': 'Lesoto',
      es: 'Lesoto',
      en: 'Lesotho',
    },
    code: 'LS',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+266',
  },
  {
    name: {
      'pt-BR': 'Líbia',
      es: 'Líbia',
      en: 'Libya',
    },
    code: 'LY',
    timezone: 'E. Europe Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+218',
  },
  {
    name: {
      'pt-BR': 'Liechtenstein',
      es: 'Liechtenstein',
      en: 'Liechtenstein',
    },
    code: 'LI',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+423',
  },
  {
    name: {
      'pt-BR': 'Lituânia',
      es: 'Lituania',
      en: 'Lithuania',
    },
    code: 'LT',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+370',
  },
  {
    name: {
      'pt-BR': 'Luxemburgo',
      es: 'Luxemburgo',
      en: 'Luxembourg',
    },
    code: 'LU',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+352',
  },
  {
    name: {
      'pt-BR': 'Macau SAR',
      es: 'Macau SAR',
      en: 'Macao SAR',
    },
    code: 'MO',
    timezone: 'China Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+853',
  },
  {
    name: {
      'pt-BR': 'Macedônia, ex-Jugoslávia',
      es: 'Macedonia, República Ex-Yugoslava de',
      en: 'Macedonia, Former Yugoslav Republic of',
    },
    code: 'MK',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+389',
  },
  {
    name: {
      'pt-BR': 'Madagascar',
      es: 'Madagascar',
      en: 'Madagascar',
    },
    code: 'MG',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+261',
  },
  {
    name: {
      'pt-BR': 'Malawi',
      es: 'Malawi',
      en: 'Malawi',
    },
    code: 'MW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+265',
  },
  {
    name: {
      'pt-BR': 'Malásia',
      es: 'Malasia',
      en: 'Malaysia',
    },
    code: 'MY',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+60',
  },
  {
    name: {
      'pt-BR': 'Maldivas',
      es: 'Maldivas',
      en: 'Maldives',
    },
    code: 'MV',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    mobileCode: '+960',
  },
  {
    name: {
      'pt-BR': 'Mali',
      es: 'Mali',
      en: 'Mali',
    },
    code: 'ML',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+223',
  },
  {
    name: {
      'pt-BR': 'Malta',
      es: 'Malta',
      en: 'Malta',
    },
    code: 'MT',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+356',
  },
  {
    name: {
      'pt-BR': 'Ilha da Man',
      es: 'Isle of Man',
      en: 'Man, Isle of',
    },
    code: 'IM',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+44-1624',
  },
  {
    name: {
      'pt-BR': 'Ilhas Marshall',
      es: 'Islas Marshall',
      en: 'Marshall Islands',
    },
    code: 'MH',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    mobileCode: '+692',
  },
  {
    name: {
      'pt-BR': 'Martinica',
      es: 'Martinica',
      en: 'Martinique',
    },
    code: 'MQ',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+596',
  },
  {
    name: {
      'pt-BR': 'Mauritânia',
      es: 'Mauritania',
      en: 'Mauritania',
    },
    code: 'MR',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+222',
  },
  {
    name: {
      'pt-BR': 'Maurício',
      es: 'Mauricio',
      en: 'Mauritius',
    },
    code: 'MU',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+230',
  },
  {
    name: {
      'pt-BR': 'Mayotte',
      es: 'Mayotte',
      en: 'Mayotte',
    },
    code: 'YT',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+262',
  },
  {
    name: {
      'pt-BR': 'México',
      es: 'México',
      en: 'Mexico',
    },
    code: 'MX',
    timezone: 'Central Standard Time (Mexico)',
    utc: 'UTC-06:00',
    mobileCode: '+52',
  },
  {
    name: {
      'pt-BR': 'Micronésia',
      es: 'Micronesia',
      en: 'Micronesia',
    },
    code: 'FM',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    mobileCode: '+691',
  },
  {
    name: {
      'pt-BR': 'Moldávia',
      es: 'Moldavia',
      en: 'Moldova',
    },
    code: 'MD',
    timezone: 'GTB Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+373',
  },
  {
    name: {
      'pt-BR': 'Mônaco',
      es: 'Mónaco',
      en: 'Monaco',
    },
    code: 'MC',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+377',
  },
  {
    name: {
      'pt-BR': 'Mongólia',
      es: 'Mongolia',
      en: 'Mongolia',
    },
    code: 'MN',
    timezone: 'Ulaanbaatar Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+976',
  },
  {
    name: {
      'pt-BR': 'Montenegro',
      es: 'Montenegro',
      en: 'Montenegro',
    },
    code: 'ME',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+382',
  },
  {
    name: {
      'pt-BR': 'Montserrat',
      es: 'Montserrat',
      en: 'Montserrat',
    },
    code: 'MS',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-664',
  },
  {
    name: {
      'pt-BR': 'Marrocos',
      es: ' Marruecos',
      en: 'Morocco',
    },
    code: 'MA',
    timezone: 'Morocco Standard Time',
    utc: 'UTC',
    mobileCode: '+212',
  },
  {
    name: {
      'pt-BR': 'Moçambique',
      es: 'Mozambique',
      en: 'Mozambique',
    },
    code: 'MZ',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+258',
  },
  {
    name: {
      'pt-BR': 'Mianmar',
      es: 'Birmania',
      en: 'Myanmar',
    },
    code: 'MM',
    timezone: 'Myanmar Standard Time',
    utc: 'UTC+06:30',
    mobileCode: '+95',
  },
  {
    name: {
      'pt-BR': 'Namíbia',
      es: 'Namibia',
      en: 'Namibia',
    },
    code: 'NA',
    timezone: 'Namibia Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+264',
  },
  {
    name: {
      'pt-BR': 'Nauru',
      es: 'Nauru',
      en: 'Nauru',
    },
    code: 'NR',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    mobileCode: '+674',
  },
  {
    name: {
      'pt-BR': 'Nepal',
      es: 'Nepal',
      en: 'Nepal',
    },
    code: 'NP',
    timezone: 'Nepal Standard Time',
    utc: 'UTC+05:45',
    mobileCode: '+977',
  },
  {
    name: {
      'pt-BR': 'Países Baixos',
      es: 'Países Bajos',
      en: 'Netherlands',
    },
    code: 'NL',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+31',
  },
  {
    name: {
      'pt-BR': 'Nova Caledônia',
      es: 'Nueva Caledonia',
      en: 'New Caledonia',
    },
    code: 'NC',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    mobileCode: '+687',
  },
  {
    name: {
      'pt-BR': 'Nova Zelândia',
      es: 'Nueva Zelanda',
      en: 'New Zealand',
    },
    code: 'NZ',
    timezone: 'New Zealand Standard Time',
    utc: 'UTC+12:00',
    mobileCode: '+64',
  },
  {
    name: {
      'pt-BR': 'Nicarágua',
      es: 'Nicaragua',
      en: 'Nicaragua',
    },
    code: 'NI',
    timezone: 'Central America Standard Time',
    utc: 'UTC-06:00',
    mobileCode: '+505',
  },
  {
    name: {
      'pt-BR': 'Níger',
      es: 'Níger',
      en: 'Niger',
    },
    code: 'NE',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+227',
  },
  {
    name: {
      'pt-BR': 'Nigéria',
      es: 'Nigeria',
      en: 'Nigeria',
    },
    code: 'NG',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+234',
  },
  {
    name: {
      'pt-BR': 'Niue',
      es: 'Niue',
      en: 'Niue',
    },
    code: 'NU',
    timezone: 'UTC-11',
    utc: 'UTC-11:00',
    mobileCode: '+683',
  },
  {
    name: {
      'pt-BR': 'Ilha Norfolk',
      es: 'Islandia de Norfolk',
      en: 'Norfolk Island',
    },
    code: 'NF',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    mobileCode: '+672',
  },
  {
    name: {
      'pt-BR': 'Coreia do Norte',
      es: 'Corea del Norte',
      en: 'North Korea',
    },
    code: 'KP',
    timezone: 'Korea Standard Time',
    utc: 'UTC+09:00',
    mobileCode: '+850',
  },
  {
    name: {
      'pt-BR': 'Ilhas Marianas do Norte',
      es: 'Islas Marianas del Norte',
      en: 'Northern Mariana Islands',
    },
    code: 'MP',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    mobileCode: '+1-670',
  },
  {
    name: {
      'pt-BR': 'Noruega',
      es: 'Noruega',
      en: 'Norway',
    },
    code: 'NO',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+47',
  },
  {
    name: {
      'pt-BR': 'Omã',
      es: 'Omán',
      en: 'Oman',
    },
    code: 'OM',
    timezone: 'Arabian Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+968',
  },
  {
    name: {
      'pt-BR': 'Paquistão',
      es: 'Paquistán',
      en: 'Pakistan',
    },
    code: 'PK',
    timezone: 'Pakistan Standard Time',
    utc: 'UTC+05:00',
    mobileCode: '+92',
  },
  {
    name: {
      'pt-BR': 'Palau',
      es: 'Palaos',
      en: 'Palau',
    },
    code: 'PW',
    timezone: 'Tokyo Standard Time',
    utc: 'UTC+09:00',
    mobileCode: '+680',
  },
  {
    name: {
      'pt-BR': 'Autoridade Palestina',
      es: 'Autoridad Palestina',
      en: 'Palestinian Authority',
    },
    code: 'PS',
    timezone: 'Egypt Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+970',
  },
  {
    name: {
      'pt-BR': 'Panamá',
      es: 'Panamá',
      en: 'Panama',
    },
    code: 'PA',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+507',
  },
  {
    name: {
      'pt-BR': 'Guiné Equatorial',
      es: 'Guinea Ecuatorial',
      en: 'Papua New Guinea',
    },
    code: 'PG',
    timezone: 'West Pacific Standard Time',
    utc: 'UTC+10:00',
    mobileCode: '+675',
  },
  {
    name: {
      'pt-BR': 'Paraguai',
      es: 'Paraguay',
      en: 'Paraguay',
    },
    code: 'PY',
    timezone: 'Paraguay Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+595',
  },
  {
    name: {
      'pt-BR': 'Peru',
      es: 'Perú',
      en: 'Peru',
    },
    code: 'PE',
    timezone: 'SA Pacific Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+51',
  },
  {
    name: {
      'pt-BR': 'Filipinas',
      es: 'Filipinas',
      en: 'Philippines',
    },
    code: 'PH',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+63',
  },
  {
    name: {
      'pt-BR': 'Ilhas Pitcairn',
      es: 'Islas Pitcairn',
      en: 'Pitcairn Islands',
    },
    code: 'PN',
    timezone: 'Pacific Standard Time',
    utc: 'UTC-08:00',
    mobileCode: '+870',
  },
  {
    name: {
      'pt-BR': 'Polônia',
      es: 'Polonia',
      en: 'Poland',
    },
    code: 'PL',
    timezone: 'Central European Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+48',
  },
  {
    name: {
      'pt-BR': 'Portugal',
      es: 'Portugal',
      en: 'Portugal',
    },
    code: 'PT',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+351',
  },
  {
    name: {
      'pt-BR': 'Porto Rico',
      es: 'Puerto Rico',
      en: 'Puerto Rico',
    },
    code: 'PR',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-787 and +1-939',
  },
  {
    name: {
      'pt-BR': 'Catar',
      es: 'Catar',
      en: 'Qatar',
    },
    code: 'QA',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+974',
  },
  {
    name: {
      'pt-BR': 'Reunião',
      es: 'Reunión',
      en: 'Reunion',
    },
    code: 'RE',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+262',
  },
  {
    name: {
      'pt-BR': 'Romênia',
      es: 'Rumania',
      en: 'Romania',
    },
    code: 'RO',
    timezone: 'GTB Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+40',
  },
  {
    name: {
      'pt-BR': 'Rússia',
      es: 'Rusia',
      en: 'Russia',
    },
    code: 'RU',
    timezone: 'Russian Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+7',
  },
  {
    name: {
      'pt-BR': 'Ruanda',
      es: 'Ruanda',
      en: 'Rwanda',
    },
    code: 'RW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+250',
  },
  {
    name: {
      'pt-BR': 'São Bartolomeu',
      es: 'San Bartolomé',
      en: 'Saint Barthélemy',
    },
    code: 'BL',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+590',
  },
  {
    name: {
      'pt-BR': 'Santa Helena, Ascensão e Tristão da Cunha',
      es: 'Santa Elena, Ascensión y Tristán da Cunha',
      en: 'Saint Helena, Ascension and Tristan da Cunha',
    },
    code: 'SH',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+290',
  },
  {
    name: {
      'pt-BR': 'São Cristóvão e Nieves',
      es: 'San Cristóbal y Nieves',
      en: 'Saint Kitts and Nevis',
    },
    code: 'KN',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-869',
  },
  {
    name: {
      'pt-BR': 'São Luís',
      es: 'San Luis',
      en: 'Saint Lucia',
    },
    code: 'LC',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-758',
  },
  {
    name: {
      'pt-BR': 'São Martinho (parte francesa)',
      es: 'San Martín (parte francesa)',
      en: 'Saint Martin (French part)',
    },
    code: 'MF',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+590',
  },
  {
    name: {
      'pt-BR': 'São Pedro e Miquelon',
      es: 'San Pedro y Miquelón',
      en: 'Saint Pierre and Miquelon',
    },
    code: 'PM',
    timezone: 'Greenland Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+508',
  },
  {
    name: {
      'pt-BR': 'São Vicente e Granadinas',
      es: 'San Vicente y las Granadinas',
      en: 'Saint Vincent and the Grenadines',
    },
    code: 'VC',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-784',
  },
  {
    name: {
      'pt-BR': 'Samoa',
      es: 'Samoa',
      en: 'Samoa',
    },
    code: 'WS',
    timezone: 'Samoa Standard Time',
    utc: 'UTC+13:00',
    mobileCode: '+685',
  },
  {
    name: {
      'pt-BR': 'San Marino',
      es: 'San Marino',
      en: 'San Marino',
    },
    code: 'SM',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+378',
  },
  {
    name: {
      'pt-BR': 'São Tomé e Príncipe',
      es: 'Santo Tomé y Príncipe',
      en: 'São Tomé and Príncipe',
    },
    code: 'ST',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+239',
  },
  {
    name: {
      'pt-BR': 'Arábia Saudita',
      es: 'Arabia Saudita',
      en: 'Saudi Arabia',
    },
    code: 'SA',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+966',
  },
  {
    name: {
      'pt-BR': 'Senegal',
      es: 'Senegal',
      en: 'Senegal',
    },
    code: 'SN',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+221',
  },
  {
    name: {
      'pt-BR': 'Sérvia',
      es: 'Serbia',
      en: 'Serbia',
    },
    code: 'RS',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+381',
  },
  {
    name: {
      'pt-BR': 'Seicheles',
      es: 'Seychelles',
      en: 'Seychelles',
    },
    code: 'SC',
    timezone: 'Mauritius Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+248',
  },
  {
    name: {
      'pt-BR': 'Serra Leoa',
      es: 'Sierra Leona',
      en: 'Sierra Leone',
    },
    code: 'SL',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+232',
  },
  {
    name: {
      'pt-BR': 'Singapura',
      es: 'Singapur',
      en: 'Singapore',
    },
    code: 'SG',
    timezone: 'Singapore Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+65',
  },
  {
    name: {
      'pt-BR': 'Sint Maarten (parte holandesa)',
      es: 'Sint Maarten (parte neerlandesa)',
      en: 'Sint Maarten (Dutch part)',
    },
    code: 'SX',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+599',
  },
  {
    name: {
      'pt-BR': 'Eslováquia',
      es: 'Eslovaquia',
      en: 'Slovakia',
    },
    code: 'SK',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+421',
  },
  {
    name: {
      'pt-BR': 'Eslovênia',
      es: 'Eslovenia',
      en: 'Slovenia',
    },
    code: 'SI',
    timezone: 'Central Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+386',
  },
  {
    name: {
      'pt-BR': 'Ilhas Salomão',
      es: 'Islas Salomón',
      en: 'Solomon Islands',
    },
    code: 'SB',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    mobileCode: '+677',
  },
  {
    name: {
      'pt-BR': 'Somália',
      es: 'Somalia',
      en: 'Somalia',
    },
    code: 'SO',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+252',
  },
  {
    name: {
      'pt-BR': 'África do Sul',
      es: 'Sudáfrica',
      en: 'South Africa',
    },
    code: 'ZA',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+27',
  },
  {
    name: {
      'pt-BR': 'Geórgia do Sul e Ilhas Sandwich do Sul',
      es: 'Georgia del Sur y las Islas Sandwich del Sur',
      en: 'South Georgia and the South Sandwich Islands',
    },
    code: 'GS',
    timezone: 'UTC-02',
    utc: 'UTC-02:00',
    mobileCode: '+44',
  },
  {
    name: {
      'pt-BR': 'Sul do Sudão',
      es: 'Sudán del Sur',
      en: 'South Sudan',
    },
    code: 'SS',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+211',
  },
  {
    name: {
      'pt-BR': 'Espanha',
      es: 'España',
      en: 'Spain',
    },
    code: 'ES',
    timezone: 'Romance Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+34',
  },
  {
    name: {
      'pt-BR': 'Sri Lanca',
      es: 'Ceilán',
      en: 'Sri Lanka',
    },
    code: 'LK',
    timezone: 'Sri Lanka Standard Time',
    utc: 'UTC+05:30',
    mobileCode: '+94',
  },
  {
    name: {
      'pt-BR': 'Sudão',
      es: 'Sudán',
      en: 'Sudan',
    },
    code: 'SD',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+249',
  },
  {
    name: {
      'pt-BR': 'Suriname',
      es: 'Surinam',
      en: 'Suriname',
    },
    code: 'SR',
    timezone: 'SA Eastern Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+597',
  },
  {
    name: {
      'pt-BR': 'Spitsbergen e Svalbard',
      es: 'Spitsbergen y Svalbard',
      en: 'Svalbard',
    },
    code: 'SJ',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+47',
  },
  {
    name: {
      'pt-BR': 'Suazi',
      es: 'Suazilandia',
      en: 'Swaziland',
    },
    code: 'SZ',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+268',
  },
  {
    name: {
      'pt-BR': 'Suécia',
      es: 'Suecia',
      en: 'Sweden',
    },
    code: 'SE',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+46',
  },
  {
    name: {
      'pt-BR': 'Suíça',
      es: 'Suiza',
      en: 'Switzerland',
    },
    code: 'CH',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+41',
  },
  {
    name: {
      'pt-BR': 'Síria',
      es: 'Siria',
      en: 'Syria',
    },
    code: 'SY',
    timezone: 'Syria Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+963',
  },
  {
    name: {
      'pt-BR': 'Taiwan',
      es: 'Taiwán',
      en: 'Taiwan',
    },
    code: 'TW',
    timezone: 'Taipei Standard Time',
    utc: 'UTC+08:00',
    mobileCode: '+886',
  },
  {
    name: {
      'pt-BR': 'Tadjiquistão',
      es: 'Tayikistán',
      en: 'Tajikistan',
    },
    code: 'TJ',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    mobileCode: '+992',
  },
  {
    name: {
      'pt-BR': 'Tanzânia',
      es: 'Tanzania',
      en: 'Tanzania',
    },
    code: 'TZ',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+255',
  },
  {
    name: {
      'pt-BR': 'Tailândia',
      es: 'Tailandia',
      en: 'Thailand',
    },
    code: 'TH',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    mobileCode: '+66',
  },
  {
    name: {
      'pt-BR': 'Togo',
      es: 'Togo',
      en: 'Togo',
    },
    code: 'TG',
    timezone: 'Greenwich Standard Time',
    utc: 'UTC',
    mobileCode: '+228',
  },
  {
    name: {
      'pt-BR': 'Tokelau',
      es: 'Tokeláu',
      en: 'Tokelau',
    },
    code: 'TK',
    timezone: 'Tonga Standard Time',
    utc: 'UTC+13:00',
    mobileCode: '+690',
  },
  {
    name: {
      'pt-BR': 'Tonga',
      es: 'Tonga',
      en: 'Tonga',
    },
    code: 'TO',
    timezone: 'Tonga Standard Time',
    utc: 'UTC+13:00',
    mobileCode: '+676',
  },
  {
    name: {
      'pt-BR': 'Trindade e Tobago',
      es: 'Trinidad y Tobago',
      en: 'Trinidad and Tobago',
    },
    code: 'TT',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-868',
  },
  {
    name: {
      'pt-BR': 'Tunísia',
      es: 'Tunez',
      en: 'Tunisia',
    },
    code: 'TN',
    timezone: 'W. Central Africa Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+216',
  },
  {
    name: {
      'pt-BR': 'Turquia',
      es: 'Turquía',
      en: 'Turkey',
    },
    code: 'TR',
    timezone: 'Turkey Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+90',
  },
  {
    name: {
      'pt-BR': 'Turcomenistão',
      es: 'Turkmenistán',
      en: 'Turkmenistan',
    },
    code: 'TM',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    mobileCode: '+993',
  },
  {
    name: {
      'pt-BR': 'Ilhas Turcas e Caicos',
      es: 'Islas Turcas y Caicos',
      en: 'Turks and Caicos Islands',
    },
    code: 'TC',
    timezone: 'Eastern Standard Time',
    utc: 'UTC-05:00',
    mobileCode: '+1-649',
  },
  {
    name: {
      'pt-BR': 'Tuvalu',
      es: 'Tuvalu',
      en: 'Tuvalu',
    },
    code: 'TV',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    mobileCode: '+688',
  },
  {
    name: {
      'pt-BR': 'Ilhas Menores Afora',
      es: 'Islas Menores Afora',
      en: 'U.S. Minor Outlying Islands',
    },
    code: 'UM',
    timezone: 'UTC-11',
    utc: 'UTC-11:00',
    mobileCode: '+1',
  },
  {
    name: {
      'pt-BR': 'Uganda',
      es: 'Uganda',
      en: 'Uganda',
    },
    code: 'UG',
    timezone: 'E. Africa Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+256',
  },
  {
    name: {
      'pt-BR': 'Ucrânia',
      es: 'Ucrania',
      en: 'Ukraine',
    },
    code: 'UA',
    timezone: 'FLE Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+380',
  },
  {
    name: {
      'pt-BR': 'Emirados Árabes Unidos',
      es: 'Emiratos Árabes Unidos',
      en: 'United Arab Emirates',
    },
    code: 'AE',
    timezone: 'Arabian Standard Time',
    utc: 'UTC+04:00',
    mobileCode: '+971',
  },
  {
    name: {
      'pt-BR': 'Reino Unido',
      es: 'Reino Unido',
      en: 'United Kingdom',
    },
    code: 'GB',
    timezone: 'GMT Standard Time',
    utc: 'UTC',
    mobileCode: '+44',
  },
  {
    name: {
      'pt-BR': 'Estados Unidos',
      es: 'Estados Unidos',
      en: 'United States',
    },
    code: 'US',
    timezone: 'Pacific Standard Time',
    utc: 'UTC-08:00',
    mobileCode: '+1',
  },
  {
    name: {
      'pt-BR': 'Uruguai',
      es: 'Uruguay',
      en: 'Uruguay',
    },
    code: 'UY',
    timezone: 'Montevideo Standard Time',
    utc: 'UTC-03:00',
    mobileCode: '+598',
  },
  {
    name: {
      'pt-BR': 'Usbequistão',
      es: 'Uzbecistán',
      en: 'Uzbekistan',
    },
    code: 'UZ',
    timezone: 'West Asia Standard Time',
    utc: 'UTC+05:00',
    mobileCode: '+998',
  },
  {
    name: {
      'pt-BR': 'Vanuatu',
      es: 'Vanuatu',
      en: 'Vanuatu',
    },
    code: 'VU',
    timezone: 'Central Pacific Standard Time',
    utc: 'UTC+11:00',
    mobileCode: '+678',
  },
  {
    name: {
      'pt-BR': 'Cidade do Vaticano',
      es: 'Ciudad del Vaticano',
      en: 'Vatican City',
    },
    code: 'VA',
    timezone: 'W. Europe Standard Time',
    utc: 'UTC+01:00',
    mobileCode: '+379',
  },
  {
    name: {
      'pt-BR': 'Vietnã',
      es: 'Vietnam',
      en: 'Vietnam',
    },
    code: 'VN',
    timezone: 'SE Asia Standard Time',
    utc: 'UTC+07:00',
    mobileCode: '+84',
  },
  {
    name: {
      'pt-BR': 'Ilhas Virgens, EUA',
      es: 'Islas Vírgenes de los Estados Unidos',
      en: 'Virgin Islands, U.S.',
    },
    code: 'VI',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-340',
  },
  {
    name: {
      'pt-BR': 'Ilhas Virgens, Reino Unido',
      es: 'Islas Vírgenes Británicas',
      en: 'Virgin Islands, British',
    },
    code: 'VG',
    timezone: 'SA Western Standard Time',
    utc: 'UTC-04:00',
    mobileCode: '+1-284',
  },
  {
    name: {
      'pt-BR': 'Wallis e Futuna',
      es: 'Wallis y Futuna',
      en: 'Wallis and Futuna',
    },
    code: 'WF',
    timezone: 'UTC+12',
    utc: 'UTC+12:00',
    mobileCode: '+681',
  },
  {
    name: {
      'pt-BR': 'Iêmen',
      es: 'Yemen',
      en: 'Yemen',
    },
    code: 'YE',
    timezone: 'Arab Standard Time',
    utc: 'UTC+03:00',
    mobileCode: '+967',
  },
  {
    name: {
      'pt-BR': 'Zâmbia',
      es: 'Zambia',
      en: 'Zambia',
    },
    code: 'ZM',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+260',
  },
  {
    name: {
      'pt-BR': 'Zimbábue',
      es: 'Zimbabue',
      en: 'Zimbabwe',
    },
    code: 'ZW',
    timezone: 'South Africa Standard Time',
    utc: 'UTC+02:00',
    mobileCode: '+263',
  },
];

export const COUNTRIES_DATA = {
  name: COUNTRIES.map((country) => country.name),
  mobileCode: COUNTRIES.map((country) => country.mobileCode),
  code: COUNTRIES.map((country) => country.code),
  utc: COUNTRIES.map((country) => country.utc),
  timezone: COUNTRIES.map((country) => country.timezone),
};
